import { render, staticRenderFns } from "./Dispositivos.vue?vue&type=template&id=a83f9b8c&scoped=true"
import script from "./Dispositivos.vue?vue&type=script&lang=js"
export * from "./Dispositivos.vue?vue&type=script&lang=js"
import style0 from "./Dispositivos.vue?vue&type=style&index=0&id=a83f9b8c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a83f9b8c",
  null
  
)

export default component.exports